import { v4 as uuidv4 } from "uuid";

/**
 * 生成UUID
 * @returns {string} UUID，形式如 xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx，其中x的范围为0~9a-f
 */
export const getUUID = () => {
  return uuidv4();
};

export const getNodeUUID = () => {
  return "node-" + uuidv4();
};

export const getRelationUUID = () => {
  return "relation-" + uuidv4();
};
